export class CustomerLookupCustomElement {
	customerId: string;
	zip: string;
	customerData: any;

	constructor() {
		this.customerId = '';
		this.zip = '';
		this.customerData = new CustomerData();
	}

	search() {
		if (this.customerId && this.zip) {
			this.customerData.name = 'Joe';
			this.customerData.address1 = '1 south High St.';
			this.customerData.city = 'Anytown';
			this.customerData.state = 'AZ';
			this.customerData.zip = this.zip;
		}
	}

	attached(customerData) {
		this.customerData = customerData;
	}
}

export class CustomerData {
	name: string = '';
	address1: string = '';
	city: string = '';
	state: string = '';
	zip: string = '';

	constructor() {
	}
}
